<template>
  <div class="bg-cover min-h-[100vh] flex flex-col">
    <NavBar></NavBar>
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <Component :key="viewKey" :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import useAuth from './composables/Auth'

const { state } = useAuth()
const route = useRoute()

// For User Emulation
const viewKey = computed(() => {
  const currentUser = state.user as {
    username?: string
    access?: number | string
    bankRZ?: { region?: string | null; zone?: string | null }
    bank_r_z?: { region?: string | null; zone?: string | null }
    bank_rz?: { region?: string | null; zone?: string | null }
  }
  const userBankRZ = currentUser.bankRZ || currentUser.bank_r_z || currentUser.bank_rz || null

  return [
    route.name ? String(route.name) : route.path,
    state.isAuthenticated ? '1' : '0',
    state.isEmulating ? '1' : '0',
    currentUser.username || '',
    String(currentUser.access ?? ''),
    userBankRZ?.region?.trim() || '',
    userBankRZ?.zone?.trim() || '',
  ].join('|')
})
</script>

<style scoped></style>
